import * as React from 'react'
import cx from 'classnames'
import { Popover, Skeleton } from '@manychat/manyui'

import MCEditorContext from 'components/MCTextEditor/MCEditorContext'
import SliceEditorWrapper from 'components/MCTextEditor/shared/components/SliceEditorWrapper'
import { ISmartLinkData } from 'components/MCTextEditor/types'
import { SliceComponent } from 'components/RichTextEditor/types'
import { safeReactLazy } from 'utils/safeReactLazy'

import cm from './SmartLinks.module.css'

const SmsLinkEditor = safeReactLazy(
  () => import('common/builder/components/builder/SmsLink/SmsLinkEditor'),
)

const SmartLinks: SliceComponent = ({ slice, processor, isSelected, input, edit }) => {
  const linkRef = React.useRef<HTMLSpanElement>(null)
  const { builderId } = React.useContext(MCEditorContext)

  const buttonId = (slice.data as ISmartLinkData).buttonId

  const handleDone = () => {
    processor.select(slice.range.end)
    edit(processor.getState())
    input?.focus()
  }

  const handleBlur = () => {
    edit(processor.getState())
    input?.focus()
  }

  const content = processor.getText().slice(slice.range.start, slice.range.end)

  return (
    <React.Fragment>
      <span ref={linkRef} className={cx('text-primary', isSelected && cm.selected)}>
        {content}
      </span>
      <Popover
        anchor={linkRef.current}
        at="right"
        arrow
        open={isSelected}
        onRequestClose={handleDone}
        className="m-y-xxs"
      >
        <SliceEditorWrapper onBlur={handleBlur}>
          {builderId && (
            <React.Suspense fallback={<Skeleton.Text lines={6} className="m-a-md" />}>
              <SmsLinkEditor builderId={builderId} buttonId={buttonId} onDoneClick={handleDone} />
            </React.Suspense>
          )}
        </SliceEditorWrapper>
      </Popover>
    </React.Fragment>
  )
}

export default SmartLinks
